import React, { useEffect } from 'react';
import { Outlet, ScrollRestoration, useLocation, useNavigate } from 'react-router';

import useInteractionTracking from '../analytics/useInteractionTracking';
import { useNProgress } from '../util/hooks/use-nprogress';
import useAppSelector from '../util/hooks/useAppSelector';
import { registerNavigate } from '../util/routes';

const setHashScrollPosition = (location) => {
  if (!location.hash) return;

  const hashId = location.hash.slice(1);
  const scrollToElement = () => {
    const el = document.getElementById(hashId);
    if (el) {
      el.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    } else {
      setTimeout(scrollToElement, 100);
    }
  };

  requestAnimationFrame(scrollToElement);
};

const RootLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useAppSelector((state) => state.user.currentUser);

  useNProgress();

  useEffect(() => {
    registerNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    setHashScrollPosition(location);
  }, [location.pathname, location.search, location.hash, location.key]);

  useInteractionTracking(location.pathname, currentUser?.id?.uuid);

  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

RootLayout.displayName = 'RootLayout';

export default RootLayout;
